export const MIDreg = /^\d{15}$/
export const IFSCCodereg = /^[A-Z|a-z]{4}[0][\d]{6}$/
export const Pincodereg = /^[1-9][0-9]{5}$/
export const MobileNumberreg = /^\d{10}$/
export const OTPreg = /^\d{6}$/
export const Passwordreg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
export const CVVreg = /^\d{3}$/
export const ExpiryCardreg = /^[0-1][0-9]\/[0-9][0-9]$/
export const gstNumberreg = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/
